"use client"

import { Input } from "@ui/input"
import { Button } from "@ui/button"
import { useState } from "react"

interface Props {
    question: string
    previousMessages: string[]
    correlationId: string
}

export function NoAnswer({ previousMessages, question, correlationId }: Props) {
    const [emailAddress, setEmailAddress] = useState("")
    const [status, setStatus] = useState<"ready" | "submitting" | "submitted" | "error">("ready")

    const sendToRay = () => {
        fetch("/labs/virtual-ray/escalations", {
            method: "POST",
            body: JSON.stringify({
                question,
                previousMessages,
                emailAddress,
                correlationId,
            }),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.ok) {
                    setStatus("submitted")
                } else {
                    setStatus("error")
                }
            })
            .catch(() => {
                setStatus("error")
            })
    }

    return (
        <div className="space-y-4 p-4">
            <p>No answer found for your question. Would you like to send your question to Ray?</p>
            <p className="text-gray-700">(Ray will try to answer all questions, but we cannot guarantee a response)</p>
            <div className="flex flex-col space-y-4 lg:flex-row lg:space-y-0 lg:space-x-4">
                <div className="grow">
                    <Input
                        type="input"
                        value={emailAddress}
                        onChange={(event) => {
                            setEmailAddress(event.target.value)
                        }}
                        placeholder="Enter your email"
                        disabled={status !== "ready"}
                    />
                </div>
                <Button
                    color="primary"
                    disabled={status !== "ready"}
                    className="mx-auto w-1/2 lg:mx-0 lg:w-auto"
                    onClick={sendToRay}
                >
                    {status === "ready"
                        ? "Send to Ray"
                        : status === "submitting"
                          ? "Sending..."
                          : status === "submitted"
                            ? "Sent!"
                            : "Error"}
                </Button>
            </div>
        </div>
    )
}
